<template>
  <div class="w-full flex flex-col gap-4 p-4 rounded-[10px]"
    :style="{ backgroundColor: cores.fundoForm, color: cores.textos }">
    <div class="flex justify-between items-center">
      <h1 class="text-xl font-bold" :style="{ color: cores.titulos }">🎨 Personalizar Tema</h1>
      <div class="flex gap-2">
        <input type="text" v-model="temaNome" placeholder="Nome do Tema" class="px-2 py-1 rounded-md text-black" />
        <button v-if="temaExiste && !temaSelecionadoPadrao" class="restore-button" @click="aplicarCores">Selecionar
          Tema</button>
        <button v-if="temaSelecionadoPadrao && !temaPertenceAoUtilizador && !jaReplicado" class="theme-button"
          @click="replicarTema">
          Replicar
        </button>


        <button v-if="temaSelecionadoId" class="theme-button" @click="editarCores">Editar Tema</button>
        <button v-if="!temaSelecionadoPadrao" class="theme-button" @click="salvarCores">Criar Tema</button>
        <button class="restore-button" @click="restaurarPadrao">Padrão</button>
      </div>
    </div>

    <div class="flex flex-wrap gap-4 p-4 rounded-[10px]" :style="{ backgroundColor: cores.fundoComponente }">
      <div v-for="(label, key) in camposCores" :key="key" class="flex flex-col items-start gap-2">
        <label class="text-sm">{{ label }}:</label>
        <input class="rounded-lg" type="color" v-model="cores[key]" @input="atualizarCores" />
      </div>
    </div>

    <div class="mt-6">
      <h2 class="text-base font-semibold mb-2">Temas Salvos</h2>
      <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        <div v-for="t in temasSalvos" :key="t.id"
          class="rounded-lg p-3 shadow cursor-pointer hover:scale-[1.02] transition-all duration-200 border"
          :style="{ backgroundColor: t.fundoApp, color: t.textos }" @click="aplicarTemaSalvo(t)">
          <div class="flex justify-between items-center mb-2">
            <h3 class="font-semibold text-lg flex items-center gap-2" :style="{ color: t.titulos }">
              <span>{{ t.tema }}</span>
              <span v-if="t.padrao" class="text-xs text-yellow-300">(Padrão)</span>
              <i v-if="t.tema === temaNome" class="fas fa-star text-yellow-400 text-lg"></i>
            </h3>

            <span class="text-xs">Clique para aplicar</span>
          </div>
          <div class="flex gap-2 text-sm">
            <div class="flex flex-col items-center">
              <div class="w-8 h-8 rounded" :style="{ backgroundColor: t.botoes }"></div>
              <span>Botões</span>
            </div>
            <div class="flex flex-col items-center">
              <div class="w-8 h-8 rounded" :style="{ backgroundColor: t.fundoForm }"></div>
              <span>Form</span>
            </div>
            <div class="flex flex-col items-center">
              <div class="w-8 h-8 rounded" :style="{ backgroundColor: t.fundoComponente }"></div>
              <span>Componente</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="mt-6 p-4 rounded-lg demo-area" :style="{ backgroundColor: cores.fundoComponente }">
      <h2 class="text-lg font-semibold mb-2" :style="{ color: cores.titulos }">Exemplo de Título</h2>
      <p :style="{ color: cores.label }">Texto de exemplo com cor personalizada.</p>

      <div class="mt-4 flex gap-4">
        <button class="theme-button">Botão</button>
        <button class="theme-button-desativado">Botão Desativado</button>
        <button class="theme-button-obrigatorio">Botão Obrigatório</button>
        <i class="fas fa-cog fa-xl icon-example"></i>
        <i class="fas fa-cog fa-xl iconCima-example"></i>
      </div>

      <div class="scroll-box mt-6">
        <div class="scroll-content">
          <p v-for="i in 10" :key="i">Linha {{ i }} com scroll...</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import { UserData as loggedUser } from '@/extraData'
import { toast } from 'vue3-toastify'

export default {
  name: 'AppThemeSwitcher',
  data() {
    return {
      temaNome: '',
      temaSelecionadoId: null,
      temaSelecionadoPadrao: false,
      baseUrl: process.env.VUE_APP_URL_BASE,
      temasSalvos: [],
      cores: {
        fundoApp: '#2e2e48',
        fundoForm: '#5d5d9873',
        fundoComponente: '#626288',
        listaRows: '#68648c',
        listaTitulo: '#4c4c6c',
        titulos: '#ff9b05',
        iconesCima: '#ffffff',
        icones: '#ff9b05',
        elevadores: '#ff9b05',
        textos: '#000000',
        botoes: '#006698',
        btnDesativado: '#b0b0b0',
        btnObrigatorio: '#b53232a2',
        label: '#ffffff',
      },
      camposCores: {
        fundoApp: 'Fundo da Aplicação',
        fundoForm: 'Fundo do Formulário',
        fundoComponente: 'Fundo do Componente',
        listaRows: 'Linhas da Lista',
        listaTitulo: 'Cabeçalho da Lista',
        botoes: 'Botões',
        titulos: 'Títulos',
        iconesCima: 'Ícones de Cima',
        icones: 'Ícones',
        elevadores: 'Elevadores',
        textos: 'Textos',
        btnDesativado: 'Desativados',
        btnObrigatorio: 'Obrigatórios',
        label: 'Labels',
      }
    }
  },
  methods: {
    async aplicarCores() {
      if (!this.temaNome) {
        toast.warning('Escolha um nome de tema para aplicar.', { autoClose: 2000 })
        return
      }
      try {
        const res = await axios.post(`${this.baseUrl}/api/v1/temas/definir_tema/`, {
          utilizador_id: loggedUser.id,
          tema: this.temaNome
        })
        if ([200, 201].includes(res.status)) {
          toast.success('Tema aplicado com sucesso!', { autoClose: 1500 })
          this.listarTemas()
        } else {
          toast.warning('Não foi possível aplicar o tema.')
        }
      } catch (err) {
        toast.error('Erro ao aplicar o tema.')
      }
    },
    async carregarCores() {
      try {
        const res = await axios.get(`${this.baseUrl}/api/v1/temas/${loggedUser.id}/`)
        if (res.data) {
          this.temaNome = res.data.tema || ''
          this.temaSelecionadoId = res.data.id
          this.temaSelecionadoPadrao = res.data.padrao
          Object.keys(this.cores).forEach(cor => {
            if (res.data[cor]) this.cores[cor] = res.data[cor]
          })
        }
        this.atualizarCores()
      } catch (err) {
        this.atualizarCores()
      }
    },
    async listarTemas() {
      try {
        const res = await axios.get(`${this.baseUrl}/api/v1/temas/listar/${loggedUser.id}/`)
        this.temasSalvos = res.data || []
      } catch (e) {
        console.warn('Erro ao listar temas salvos')
      }
    },
    atualizarCores() {
      const vars = {
        '--fundoApp': this.cores.fundoApp,
        '--fundoForm': this.cores.fundoForm,
        '--fundoComponente': this.cores.fundoComponente,
        '--linhaLista': this.cores.listaRows,
        '--colunaLista': this.cores.listaTitulo,
        '--titulo': this.cores.titulos,
        '--iconCima': this.cores.iconesCima,
        '--icon': this.cores.icones,
        '--scroll': this.cores.elevadores,
        '--text': this.cores.textos,
        '--button': this.cores.botoes,
        '--desativado': this.cores.btnDesativado,
        '--obrigatorio': this.cores.btnObrigatorio,
        '--label': this.cores.label,
      }
      Object.entries(vars).forEach(([k, v]) => {
        document.documentElement.style.setProperty(k, v)
      })
    },
    async salvarCores() {
      if (!this.temaNome) {
        toast.warning('Escolha um nome para o tema.', { autoClose: 2000 })
        return
      }
      const payload = {
        utilizador_id: loggedUser.id,
        tema: this.temaNome,
        ...this.cores
      }
      try {
        const res = await axios.post(`${this.baseUrl}/api/v1/temas/registrar/`, payload)
        if ([200, 201].includes(res.status)) {
          toast.success('Cores salvas com sucesso!', { autoClose: 1500 })
          this.temaNome = ''
          this.temaSelecionadoId = null
          this.listarTemas()
        }
      } catch (error) {
        toast.error('Erro ao salvar cores!')
      }
    },
    async editarCores() {
      if (!this.temaSelecionadoId) {
        toast.warning('Nenhum tema selecionado.', { autoClose: 2000 })
        return
      }

      if (this.temaSelecionadoPadrao && ![1, 157].includes(loggedUser.id)) {
        toast.warning('Apenas utilizadores autorizados podem editar temas padrão.', { autoClose: 2500 })
        return
      }

      const payload = {
        utilizador_id: loggedUser.id,
        tema: this.temaNome,
        ...this.cores
      }

      try {
        const res = await axios.put(`${this.baseUrl}/api/v1/temas/editar/${this.temaSelecionadoId}/`, payload)
        if (res.status === 200) {
          toast.success('Tema editado com sucesso!', { autoClose: 1500 })
          this.temaSelecionadoId = null
          this.temaNome = ''
          this.listarTemas()
        }
      } catch (err) {
        toast.error('Erro ao editar o tema.')
      }
    },
    aplicarTemaSalvo(tema) {
      this.temaNome = tema.tema
      this.temaSelecionadoId = tema.id
      this.temaSelecionadoPadrao = tema.padrao
      Object.keys(this.cores).forEach(chave => {
        this.cores[chave] = tema[chave]
      })
      this.atualizarCores()
      toast.success(`Tema "${tema.tema}" aplicado`, { autoClose: 1200 })
    },

    async replicarTema() {
      try {
        const temaPadrao = this.temasSalvos.find(t => t.tema === this.temaNome && t.padrao)
        if (!temaPadrao) {
          toast.warning('Tema padrão não encontrado.', { autoClose: 2000 })
          return
        }

        const nomeReplica = `( ${temaPadrao.tema} ) - Replica`

        const jaExiste = this.temasSalvos.some(
          t => t.tema === nomeReplica && t.utilizador_id === loggedUser.id
        )

        if (jaExiste) {
          toast.info('Este tema padrão já foi replicado.', { autoClose: 2000 })
          return
        }

        const payload = {
          utilizador_id: loggedUser.id,
          tema: nomeReplica,
        }

        Object.keys(this.cores).forEach(key => {
          payload[key] = temaPadrao[key]
        })

        // Cria o novo tema replicado
        const res = await axios.post(`${this.baseUrl}/api/v1/temas/registrar/`, payload)

        if ([200, 201].includes(res.status)) {
          toast.success('Tema replicado com sucesso!', { autoClose: 1500 })

          // Aplica imediatamente
          await axios.post(`${this.baseUrl}/api/v1/temas/definir_tema/`, {
            utilizador_id: loggedUser.id,
            tema: nomeReplica
          })

          this.temaNome = nomeReplica
          this.temaSelecionadoId = null

          await this.listarTemas()
          await this.carregarCores()
        }
      } catch (err) {
        toast.error('Erro ao replicar o tema.')
      }
    }
    ,


    restaurarPadrao() {
      this.cores = {
        fundoApp: '#2e2e48',
        fundoForm: '#5d5d9873',
        fundoComponente: '#626288',
        listaRows: '#68648c',
        listaTitulo: '#4c4c6c',
        titulos: '#ff9b05',
        iconesCima: '#ffffff',
        icones: '#ff9b05',
        elevadores: '#ff9b05',
        textos: '#000000',
        botoes: '#006698',
        btnDesativado: '#b0b0b0',
        btnObrigatorio: '#b53232a2',
        label: '#ffffff',
      }
      this.temaNome = ''
      this.temaSelecionadoId = null
      this.atualizarCores()
      toast.info('Cores padrão restauradas.', { autoClose: 1500 })
    }
  },
  computed: {
    temaExiste() {
      return this.temasSalvos.some(t => t.tema === this.temaNome)
    },
    temaPertenceAoUtilizador() {
      const tema = this.temasSalvos.find(t => t.tema === this.temaNome)
      return tema && tema.utilizador_id === loggedUser.id
    },
    jaReplicado() {
      const nomeReplica = `Tema Padrão (${loggedUser.nome}) - ${this.temaNome}`
      return this.temasSalvos.some(
        t => t.tema === nomeReplica && t.utilizador_id === loggedUser.id
      )
    }

  },
  mounted() {
    this.carregarCores()
    this.listarTemas()
  }
}
</script>

<style scoped>
input[type='color'] {
  width: 50px;
  height: 50px;
  border: none;
  cursor: pointer;
  background: none;
}

.theme-button {
  background-color: var(--button);
  color: white;
  padding: 0.5rem 1rem;
  border-radius: 10px;
  font-weight: bold;
  cursor: pointer;
  transition: 0.3s;
}

.theme-button-desativado {
  background-color: var(--desativado);
  color: white;
  padding: 0.5rem 1rem;
  border-radius: 10px;
  font-weight: bold;
  cursor: pointer;
  transition: 0.3s;
}

.theme-button-obrigatorio {
  background-color: var(--obrigatorio);
  color: white;
  padding: 0.5rem 1rem;
  border-radius: 10px;
  font-weight: bold;
  cursor: pointer;
  transition: 0.3s;
}

.theme-button:hover,
.theme-button-desativado:hover,
.restore-button:hover {
  opacity: 0.85;
}

.restore-button {
  background-color: white;
  color: black;
  padding: 0.5rem 1rem;
  border-radius: 10px;
  font-weight: bold;
  cursor: pointer;
  transition: 0.3s;
}

.icon-example {
  color: var(--icon);
}

.iconCima-example {
  color: var(--iconCima);
}

.scroll-box {
  max-height: 150px;
  overflow-y: auto;
  background-color: rgba(255, 255, 255, 0.05);
  border-radius: 5px;
  padding: 1rem;
}

.scroll-content p {
  margin: 0;
  padding: 0.2rem;
}

.scroll-box::-webkit-scrollbar {
  width: 8px;
}

.scroll-box::-webkit-scrollbar-thumb {
  background-color: var(--scroll);
  border-radius: 10px;
}

.scroll-box::-webkit-scrollbar-track {
  background: transparent;
}
</style>
